import { apiFloristGatewayService } from './apiService/HttpService';
import { setEndPoint } from './apiService/SetEndPoint';
import { endPoints } from './apiService/EndPoints';

class OrdersListService {
  static getordersListData(data) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.ordersListData),
      params: data,
    });
  }

  static getOverdueOrdersList(data) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.overdueOrdersList),
      params: data,
    });
  }

  static getAssignedOrdersList(data) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.assignedOrdersList),
      params: data,
    });
  }

  static getAssignedOrdersCount(data) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.assignedOrdersCount),
      params: data,
    });
  }

  static getSubAndB2bOps(mainOpsId) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.subAndB2bOps, mainOpsId),
    });
  }

  static getFloristsList(params, ...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.getFloristsList, ...extraParams),
      params,
    });
  }

  static getCompletedOrders(params, ...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.completedOrders, ...extraParams),
      params,
    });
  }

  static assignFloristStatus(params, ...extraParams) {
    return apiFloristGatewayService({
      method: 'PUT',
      url: setEndPoint(endPoints.assignFlorist, ...extraParams),
      params,
    });
  }

  static changeOrderPreparationStatus(data, ...extraParams) {
    return apiFloristGatewayService({
      method: 'PUT',
      url: setEndPoint(endPoints.changeOrderPreparationStatus, ...extraParams),
      data,
    });
  }

  static getGroupedBySku(params, ...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.groupedBy, ...extraParams),
      params,
    });
  }

  static getGroupedByZone(params, ...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.groupedBy, ...extraParams),
      params,
    });
  }

  static getExpressOrdersListing(params) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.expressOrdersListing),
      params,
    });
  }

  static getExpressOrdersCount() {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.expressOrdersCount),
    });
  }

  static NotDoneList(...extraParams) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.notDoneReasonsList, ...extraParams),
    });
  }
}
export default OrdersListService;
